import { useSelector } from 'react-redux';
import Pluralize from 'react-pluralize';

import { StyledCoffeeSummary } from './style';

const CoffeeSummaryItem = ({ coffeeId, quantity }) => {
  const coffees = useSelector((state) => state.coffees);

  let coffee = coffees.find(coffee => parseInt(coffee.id) === parseInt(coffeeId));

  if(coffee){
    return (
      <div className="item">
        {coffee.name}: <strong><Pluralize singular="pacote" count={quantity} /></strong>
      </div>
    )
  }
  else return null;
}

const CoffeeSummary = ({ coffees }) => {
  const subscription = useSelector((state) => state.subscription);

  if(subscription.orderType === 1 && coffees && Object.keys(coffees).length > 0){
    return (
      <StyledCoffeeSummary>
        {
          Object.keys(coffees).map((id, i) => (
            <CoffeeSummaryItem
              key={i}
              coffeeId={id}
              quantity={coffees[id]}
            />
          ))
        }
      </StyledCoffeeSummary>
    )
  }
  else return null;
}

export default CoffeeSummary;
